import { render, staticRenderFns } from "./View_Employee.vue?vue&type=template&id=a870cfa0&"
import script from "./View_Employee.vue?vue&type=script&lang=js&"
export * from "./View_Employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports